import React from 'react';
import { Button } from '@material-ui/core';

const Simples = ({ energia, classes, handleButtonCiclo }) => {
  return (
    <div>
      <Button
        name='diario'
        onClick={(e, value) => handleButtonCiclo(e, (value = 'diario'))}
        className={
          energia.ciclo === 'diario'
            ? classes.btnActiveTiny
            : classes.btnNormalTiny
        }
      >
        <div>Diário</div>
      </Button>
      <Button
        name='semanal'
        onClick={(e, value) => handleButtonCiclo(e, (value = 'semanal'))}
        className={
          energia.ciclo === 'semanal'
            ? classes.btnActiveTiny
            : classes.btnNormalTiny
        }
      >
        <div>Semanal</div>
      </Button>
    </div>
  );
};

export default Simples;
